import { Button } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type PillButtonProps = {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
};

export function PillButton({
  label,
  onClick,
  disabled = false,
  fullWidth = false,
}: PillButtonProps) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      radius="9999"
      size="md"
      fw={FONT_WEIGHTS.semibold}
      styles={theme => ({
        root: {
          height: 48,
          paddingLeft: 16,
          paddingRight: 16,
          borderRadius: 9999,
          fontSize: theme.fontSizes.md,
          fontWeight: 600,

          backgroundColor: disabled ? theme.colors.gray[2] : theme.colors.brand[6],

          cursor: disabled ? 'not-allowed' : 'pointer',

          '&:hover': {
            backgroundColor: disabled ? theme.colors.gray[2] : theme.colors.brand[7],
          },
        },
        label: {
          color: disabled ? theme.colors.gray[6] : theme.white,
        },
      })}
    >
      {label}
    </Button>
  );
}
